import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Box,
  TablePagination,
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";

const muiTheme = createTheme({
  palette: {
    primary: {
      main: "#136F63",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#1E40AF",
    },
    accent: {
      main: "#38BDF8",
    },
  },
});

const DataTable = ({
  columns,
  rows,
  onEdit,
  loading,
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
}) => {
  return (
    <ThemeProvider theme={muiTheme}>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow
              sx={{
                height: "2.5rem",
                backgroundColor: "primary.main",
              }}
            >
              {columns.map((col) => (
                <TableCell
                  sx={{
                    color: "primary.contrastText",
                    fontWeight: 500,
                    width: col.width,
                    whiteSpace: "nowrap"
                  }}
                  key={col.field}
                >
                  {col.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell
                  colSpan={columns.length}
                  align="center"
                  sx={{ py: 3 }}

                >
                  <Box
                    sx={{ display: "flex", justifyContent: "center", my: 2 }}
                  >
                    <CircularProgress size={24} color="primary" />
                  </Box>
                </TableCell>
              </TableRow>
            ) : rows?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  No data available
                </TableCell>
              </TableRow>
            ) : (
              rows?.map((row, index) => (
                <TableRow key={row._id || index} sx={{ whiteSpace: "nowrap" }}>
                  {columns.map((col) => (
                    <TableCell key={col.field} align={col.align ?? "left"} width={col.width}>
                      {col.renderCell
                        ? col.renderCell(row, onEdit)
                        : row[col.field]}
                    </TableCell>
                  ))}
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        // rowsPerPageOptions={[10, 50, 100, { label: "All", value: 1000 }]}
        rowsPerPageOptions={[50, 100]}
        component="div"
        count={totalCount || 0}
        rowsPerPage={rowsPerPage || 100}
        page={page || 0}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
      />
    </ThemeProvider>
  );
};

export default DataTable;
